import React from 'react';
import { FieldSet } from '../../components/Form';
import ReorderableList from '../../components/ReorderableList';
import SeriesRow from '../SeriesRow';
import SeriesAddPost from './SeriesAddPost';
import * as styles from './SeriesPostManager.module.scss';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { SeriesAddPost_PostFragment } from '../../graphql/generated/graphql';

const POSTS_FRAGMENT = gql(`
  fragment SeriesPostManager_posts on Post {
    id
    ...SeriesAddPost_post
    ...SeriesRow_post
  }
`);

interface SeriesPostManagerProps {
  seriesId?: string;
  requiredPostId?: string;
  onAdd(post: SeriesAddPost_PostFragment): void;
  onRemove(index: number): void;
  onMove(sourceIndex: number, destinationIndex: number): void;
  posts: DocumentType<typeof POSTS_FRAGMENT>[];
}

const SeriesPostManager = ({
  posts,
  requiredPostId,
  seriesId,
  onAdd,
  onRemove,
  onMove,
}: SeriesPostManagerProps) => (
  <FieldSet legend="Order">
    <ReorderableList
      name="posts"
      onMove={onMove}
      onRemove={onRemove}
      items={posts}
      renderItem={(post, index) => (
        <SeriesRow post={post} index={index} noLink noPadding />
      )}
      isRemovable={(post) => posts.length > 1 && post.id !== requiredPostId}
    />
    <div className={styles.addContainer}>
      <SeriesAddPost posts={posts} seriesId={seriesId} onAdd={onAdd} />
    </div>
  </FieldSet>
);

export default SeriesPostManager;
